import { render, staticRenderFns } from "./Assessments.vue?vue&type=template&id=53a93512&scoped=true&"
import script from "./Assessments.vue?vue&type=script&lang=js&"
export * from "./Assessments.vue?vue&type=script&lang=js&"
import style0 from "./Assessments.vue?vue&type=style&index=0&id=53a93512&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a93512",
  null
  
)

export default component.exports